import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "raport-vanzari" }
const _hoisted_2 = { class: "nav-menu" }
const _hoisted_3 = { class: "nav-label" }
const _hoisted_4 = { class: "filter-row" }
const _hoisted_5 = { class: "filter-group" }
const _hoisted_6 = { class: "filter-group ml-4" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-center align-center py-8"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "summary-inner" }
const _hoisted_10 = {
  class: "summary-icon",
  style: {"background":"rgba(33,150,243,0.1)"}
}
const _hoisted_11 = { class: "summary-value" }
const _hoisted_12 = { class: "summary-inner" }
const _hoisted_13 = {
  class: "summary-icon",
  style: {"background":"rgba(76,175,80,0.1)"}
}
const _hoisted_14 = { class: "summary-value summary-value--small" }
const _hoisted_15 = { class: "summary-inner" }
const _hoisted_16 = { class: "summary-inner" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "agent-header" }
const _hoisted_19 = { class: "agent-name" }
const _hoisted_20 = { class: "agent-cifra-row" }
const _hoisted_21 = { class: "agent-cifra-val" }
const _hoisted_22 = { class: "agent-marja-row" }
const _hoisted_23 = {
  key: 0,
  class: "agent-detalii"
}
const _hoisted_24 = {
  key: 0,
  class: "detalii-empty"
}
const _hoisted_25 = {
  key: 0,
  class: "doc-group"
}
const _hoisted_26 = { class: "doc-group-header doc-group-header--aviz" }
const _hoisted_27 = { class: "doc-group-count" }
const _hoisted_28 = { class: "detalii-scroll" }
const _hoisted_29 = { class: "detalii-table" }
const _hoisted_30 = { class: "col-numar" }
const _hoisted_31 = {
  key: 0,
  class: "badge-partial"
}
const _hoisted_32 = {
  key: 1,
  class: "badge-storno-linii"
}
const _hoisted_33 = { class: "col-data" }
const _hoisted_34 = { class: "col-num" }
const _hoisted_35 = { class: "col-num" }
const _hoisted_36 = {
  key: 1,
  class: "doc-group"
}
const _hoisted_37 = { class: "doc-group-header doc-group-header--fara-aviz" }
const _hoisted_38 = { class: "doc-group-count" }
const _hoisted_39 = { class: "detalii-scroll" }
const _hoisted_40 = { class: "detalii-table" }
const _hoisted_41 = { class: "col-numar" }
const _hoisted_42 = {
  key: 0,
  class: "badge-partial"
}
const _hoisted_43 = {
  key: 1,
  class: "badge-storno-linii"
}
const _hoisted_44 = { class: "col-data" }
const _hoisted_45 = { class: "col-num" }
const _hoisted_46 = { class: "col-num" }
const _hoisted_47 = {
  key: 2,
  class: "doc-group"
}
const _hoisted_48 = { class: "doc-group-header doc-group-header--storno" }
const _hoisted_49 = { class: "doc-group-count" }
const _hoisted_50 = { class: "detalii-scroll" }
const _hoisted_51 = { class: "detalii-table" }
const _hoisted_52 = { class: "col-numar" }
const _hoisted_53 = { class: "col-data" }
const _hoisted_54 = { class: "col-num col-storno" }
const _hoisted_55 = { class: "col-num col-storno" }
const _hoisted_56 = { class: "col-num" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "nav-menu-card",
      elevation: "2"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: index,
              to: item.route,
              class: _normalizeClass(["nav-item", { 'active': _ctx.isActiveRoute(item.route) }])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: _ctx.isActiveRoute(item.route) ? _ctx.APP_Color : '#718096',
                  size: "20"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.icon), 1)
                  ]),
                  _: 2
                }, 1032, ["color"]),
                _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      class: "filter-card mb-4",
      elevation: "1"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-1",
              color: "grey"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("mdi-calendar-month", -1)
              ]))]),
              _: 1
            }),
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "filter-label" }, "Perioadă:", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.lunaSelectata,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lunaSelectata) = $event)),
              items: _ctx.luni,
              "item-title": "label",
              "item-value": "value",
              density: "compact",
              variant: "outlined",
              "hide-details": "",
              class: "filter-select ml-2"
            }, null, 8, ["modelValue", "items"]),
            _createVNode(_component_v_select, {
              modelValue: _ctx.anSelectat,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.anSelectat) = $event)),
              items: _ctx.ani,
              density: "compact",
              variant: "outlined",
              "hide-details": "",
              class: "filter-select ml-2"
            }, null, 8, ["modelValue", "items"]),
            _createVNode(_component_v_btn, {
              color: _ctx.APP_Color,
              density: "compact",
              class: "ml-3 refresh-btn",
              loading: _ctx.loading,
              onClick: _ctx.incarcaRaport
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "16",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("mdi-refresh", -1)
                  ]))]),
                  _: 1
                }),
                _cache[5] || (_cache[5] = _createTextVNode(" Actualizează ", -1))
              ]),
              _: 1
            }, 8, ["color", "loading", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-1",
              color: "grey"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("mdi-magnify", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.searchAgent,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchAgent) = $event)),
              placeholder: "Caută agent...",
              density: "compact",
              variant: "outlined",
              "hide-details": "",
              clearable: "",
              style: {"width":"320px","min-width":"320px"}
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: _ctx.APP_Color,
            size: "48"
          }, null, 8, ["color"])
        ]))
      : (!_ctx.loading && _ctx.raportData.length === 0 && _ctx.hasLoaded)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 1,
            type: "info",
            variant: "tonal",
            class: "mb-4"
          }, {
            title: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("Nicio înregistrare", -1)
            ]))]),
            default: _withCtx(() => [
              _cache[9] || (_cache[9] = _createTextVNode(" Nu există documente cu agent asociat pentru ", -1)),
              _createElementVNode("strong", null, _toDisplayString(_ctx.lunaNume) + " " + _toDisplayString(_ctx.anSelectat), 1),
              _cache[10] || (_cache[10] = _createTextVNode(". ", -1))
            ]),
            _: 1
          }))
        : (!_ctx.loading && _ctx.raportData.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_v_row, {
                class: "mb-4",
                dense: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "summary-card",
                        elevation: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_v_icon, {
                                color: "#2196F3",
                                size: "24"
                              }, {
                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                  _createTextVNode("mdi-account-group", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.raportData.length), 1),
                              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "summary-label" }, "Agenți activi", -1))
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "summary-card",
                        elevation: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_v_icon, {
                                color: "#4CAF50",
                                size: "24"
                              }, {
                                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                  _createTextVNode("mdi-cash-multiple", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.formatValoare(_ctx.totalCifra)), 1),
                              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "summary-label" }, "Cifră totală", -1))
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "summary-card",
                        elevation: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", {
                              class: "summary-icon",
                              style: _normalizeStyle({ background: `rgba(${_ctx.marjaColorRGB(_ctx.totalMarjaPct)}, 0.1)` })
                            }, [
                              _createVNode(_component_v_icon, {
                                color: _ctx.getMarjaColor(_ctx.totalMarjaPct),
                                size: "24"
                              }, {
                                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                  _createTextVNode("mdi-trending-up", -1)
                                ]))]),
                                _: 1
                              }, 8, ["color"])
                            ], 4),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", {
                                class: "summary-value summary-value--small",
                                style: _normalizeStyle({ color: _ctx.getMarjaColor(_ctx.totalMarjaPct) })
                              }, _toDisplayString(_ctx.formatValoare(_ctx.totalMarjaValoare)), 5),
                              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "summary-label" }, "Marjă totală", -1))
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "summary-card",
                        elevation: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", {
                              class: "summary-icon",
                              style: _normalizeStyle({ background: `rgba(${_ctx.marjaColorRGB(_ctx.totalMarjaPct)}, 0.1)` })
                            }, [
                              _createVNode(_component_v_icon, {
                                color: _ctx.getMarjaColor(_ctx.totalMarjaPct),
                                size: "24"
                              }, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                  _createTextVNode("mdi-percent", -1)
                                ]))]),
                                _: 1
                              }, 8, ["color"])
                            ], 4),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", {
                                class: "summary-value",
                                style: _normalizeStyle({ color: _ctx.getMarjaColor(_ctx.totalMarjaPct) })
                              }, _toDisplayString(_ctx.totalMarjaPct.toFixed(1)) + "% ", 5),
                              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "summary-label" }, "Marjă medie ponderată", -1))
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { dense: "" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.raportDataFiltrat, (agent) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      key: agent.AgentId,
                      cols: "12",
                      sm: "6",
                      md: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: _normalizeClass(["agent-card", { 'agent-card--expanded': _ctx.expandedId === agent.AgentId }]),
                          elevation: "1"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "agent-card-inner",
                              onClick: ($event: any) => (_ctx.toggleDetalii(agent)),
                              style: {"cursor":"pointer"}
                            }, [
                              _createElementVNode("div", _hoisted_18, [
                                (agent.AgentCod)
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 0,
                                      size: "x-small",
                                      color: "blue-grey",
                                      variant: "tonal",
                                      label: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(agent.AgentCod), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_chip, {
                                  size: "x-small",
                                  variant: "tonal",
                                  class: "ml-1",
                                  color: agent.NrDocumente > 0 ? 'blue' : 'grey'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(agent.NrDocumente) + " doc. ", 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"]),
                                (agent.FacturiCuAviz?.length)
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 1,
                                      size: "x-small",
                                      color: "blue",
                                      variant: "tonal",
                                      class: "ml-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(agent.FacturiCuAviz.length) + " aviz ", 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                (agent.FacturiFaraAviz?.length)
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 2,
                                      size: "x-small",
                                      color: "purple",
                                      variant: "tonal",
                                      class: "ml-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(agent.FacturiFaraAviz.length) + " serv. ", 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                (agent.FacturiStorno?.length)
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 3,
                                      size: "x-small",
                                      color: "red",
                                      variant: "tonal",
                                      class: "ml-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(agent.FacturiStorno.length) + " storno ", 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_icon, {
                                  class: _normalizeClass(["ml-auto expand-icon", { 'expand-icon--open': _ctx.expandedId === agent.AgentId }]),
                                  size: "18",
                                  color: "grey"
                                }, {
                                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                    _createTextVNode("mdi-chevron-down", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["class"])
                              ]),
                              _createElementVNode("div", _hoisted_19, _toDisplayString(agent.AgentNume), 1),
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.formatValoare(agent.Cifra)), 1),
                                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "agent-cifra-label" }, "RON cifră", -1))
                              ]),
                              _createElementVNode("div", _hoisted_22, [
                                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "agent-marja-label" }, "Marjă:", -1)),
                                _createElementVNode("span", {
                                  class: "agent-marja-val",
                                  style: _normalizeStyle({ color: _ctx.getMarjaColor(agent.MarjaProcentaj) })
                                }, _toDisplayString(_ctx.formatValoare(agent.MarjaValoare)) + " RON ", 5),
                                _createElementVNode("span", {
                                  class: "agent-pct ml-auto",
                                  style: _normalizeStyle({ color: _ctx.getMarjaColor(agent.MarjaProcentaj) })
                                }, _toDisplayString(agent.MarjaProcentaj.toFixed(1)) + "% ", 5)
                              ])
                            ], 8, _hoisted_17),
                            _createVNode(_component_v_expand_transition, null, {
                              default: _withCtx(() => [
                                (_ctx.expandedId === agent.AgentId)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                      (!agent.FacturiCuAviz?.length && !agent.FacturiFaraAviz?.length && !agent.FacturiStorno?.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                            _createVNode(_component_v_icon, {
                                              size: "20",
                                              color: "grey-lighten-1"
                                            }, {
                                              default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                                _createTextVNode("mdi-information-outline", -1)
                                              ]))]),
                                              _: 1
                                            }),
                                            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "ml-1" }, "Nicio înregistrare găsită.", -1))
                                          ]))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (agent.FacturiCuAviz?.length)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                  _createElementVNode("div", _hoisted_26, [
                                                    _createVNode(_component_v_icon, {
                                                      size: "13",
                                                      class: "mr-1"
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                                        _createTextVNode("mdi-truck-check", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _cache[25] || (_cache[25] = _createTextVNode(" Facturi cu aviz ", -1)),
                                                    _createElementVNode("span", _hoisted_27, _toDisplayString(agent.FacturiCuAviz.length), 1)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_28, [
                                                    _createElementVNode("table", _hoisted_29, [
                                                      _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", null, [
                                                          _createElementVNode("th", null, "Nr. Document"),
                                                          _createElementVNode("th", null, "Data"),
                                                          _createElementVNode("th", { class: "col-num" }, "Cifră"),
                                                          _createElementVNode("th", { class: "col-num" }, "Marjă val."),
                                                          _createElementVNode("th", { class: "col-num" }, "Marjă %")
                                                        ])
                                                      ], -1)),
                                                      _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agent.FacturiCuAviz, (doc) => {
                                                          return (_openBlock(), _createElementBlock("tr", {
                                                            key: doc.DocumentId
                                                          }, [
                                                            _createElementVNode("td", _hoisted_30, [
                                                              _createTextVNode(_toDisplayString(doc.Numar || '—') + " ", 1),
                                                              (doc.LivrataPartial)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "livrat parțial"))
                                                                : _createCommentVNode("", true),
                                                              (doc.AreLiniiStorno)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, "linii storno"))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.formatData(doc.Data)), 1),
                                                            _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.formatValoare(doc.Cifra)), 1),
                                                            _createElementVNode("td", {
                                                              class: "col-num",
                                                              style: _normalizeStyle({ color: _ctx.getMarjaColor(doc.MarjaProcentaj) })
                                                            }, _toDisplayString(_ctx.formatValoare(doc.MarjaValoare)), 5),
                                                            _createElementVNode("td", _hoisted_35, [
                                                              _createVNode(_component_v_chip, {
                                                                size: "x-small",
                                                                variant: "tonal",
                                                                color: doc.MarjaProcentaj >= 20 ? 'green' : doc.MarjaProcentaj >= 10 ? 'orange' : 'red'
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(doc.MarjaProcentaj.toFixed(1)) + "% ", 1)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["color"])
                                                            ])
                                                          ]))
                                                        }), 128))
                                                      ])
                                                    ])
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (agent.FacturiFaraAviz?.length)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                  _createElementVNode("div", _hoisted_37, [
                                                    _createVNode(_component_v_icon, {
                                                      size: "13",
                                                      class: "mr-1"
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                                        _createTextVNode("mdi-file-document-outline", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _cache[28] || (_cache[28] = _createTextVNode(" Facturi fără aviz ", -1)),
                                                    _createElementVNode("span", _hoisted_38, _toDisplayString(agent.FacturiFaraAviz.length), 1)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_39, [
                                                    _createElementVNode("table", _hoisted_40, [
                                                      _cache[29] || (_cache[29] = _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", null, [
                                                          _createElementVNode("th", null, "Nr. Document"),
                                                          _createElementVNode("th", null, "Data"),
                                                          _createElementVNode("th", { class: "col-num" }, "Cifră"),
                                                          _createElementVNode("th", { class: "col-num" }, "Marjă val."),
                                                          _createElementVNode("th", { class: "col-num" }, "Marjă %")
                                                        ])
                                                      ], -1)),
                                                      _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agent.FacturiFaraAviz, (doc) => {
                                                          return (_openBlock(), _createElementBlock("tr", {
                                                            key: doc.DocumentId + '-fara'
                                                          }, [
                                                            _createElementVNode("td", _hoisted_41, [
                                                              _createTextVNode(_toDisplayString(doc.Numar || '—') + " ", 1),
                                                              (doc.LivrataPartial)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_42, "livrat parțial"))
                                                                : _createCommentVNode("", true),
                                                              (doc.AreLiniiStorno)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_43, "linii storno"))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.formatData(doc.Data)), 1),
                                                            _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.formatValoare(doc.Cifra)), 1),
                                                            _createElementVNode("td", {
                                                              class: "col-num",
                                                              style: _normalizeStyle({ color: _ctx.getMarjaColor(doc.MarjaProcentaj) })
                                                            }, _toDisplayString(_ctx.formatValoare(doc.MarjaValoare)), 5),
                                                            _createElementVNode("td", _hoisted_46, [
                                                              _createVNode(_component_v_chip, {
                                                                size: "x-small",
                                                                variant: "tonal",
                                                                color: doc.MarjaProcentaj >= 20 ? 'green' : doc.MarjaProcentaj >= 10 ? 'orange' : 'red'
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(doc.MarjaProcentaj.toFixed(1)) + "% ", 1)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["color"])
                                                            ])
                                                          ]))
                                                        }), 128))
                                                      ])
                                                    ])
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (agent.FacturiStorno?.length)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                  _createElementVNode("div", _hoisted_48, [
                                                    _createVNode(_component_v_icon, {
                                                      size: "13",
                                                      class: "mr-1"
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                                        _createTextVNode("mdi-swap-horizontal", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _cache[31] || (_cache[31] = _createTextVNode(" Facturi storno ", -1)),
                                                    _createElementVNode("span", _hoisted_49, _toDisplayString(agent.FacturiStorno.length), 1)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_50, [
                                                    _createElementVNode("table", _hoisted_51, [
                                                      _cache[32] || (_cache[32] = _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", null, [
                                                          _createElementVNode("th", null, "Nr. Document"),
                                                          _createElementVNode("th", null, "Data"),
                                                          _createElementVNode("th", { class: "col-num" }, "Cifră"),
                                                          _createElementVNode("th", { class: "col-num" }, "Marjă val."),
                                                          _createElementVNode("th", { class: "col-num" }, "Marjă %")
                                                        ])
                                                      ], -1)),
                                                      _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agent.FacturiStorno, (doc) => {
                                                          return (_openBlock(), _createElementBlock("tr", {
                                                            key: doc.DocumentId
                                                          }, [
                                                            _createElementVNode("td", _hoisted_52, _toDisplayString(doc.Numar || '—'), 1),
                                                            _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.formatData(doc.Data)), 1),
                                                            _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.formatValoare(doc.Cifra)), 1),
                                                            _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.formatValoare(doc.MarjaValoare)), 1),
                                                            _createElementVNode("td", _hoisted_56, [
                                                              _createVNode(_component_v_chip, {
                                                                size: "x-small",
                                                                variant: "tonal",
                                                                color: "red"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(doc.MarjaProcentaj.toFixed(1)) + "% ", 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ])
                                                          ]))
                                                        }), 128))
                                                      ])
                                                    ])
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["class"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
  ]))
}